// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import EventEmitter from 'events';
// After full transfer to react, use react Context for sharing callback 'openContextMenu' between components
export var ContextEvents;
(function (ContextEvents) {
    ContextEvents["OpenAccountLookupDropDownForm"] = "openAccountLookupDropDownForm";
})(ContextEvents || (ContextEvents = {}));
class ContextHandler {
    constructor() {
        this.eventEmitter = new EventEmitter();
    }
    subscribe(event, callback) {
        this.eventEmitter.on(event, callback);
    }
    unsubscribe(event, callback) {
        this.eventEmitter.off(event, callback);
    }
    emit(event, ...args) {
        this.eventEmitter.emit(event, ...args);
    }
}
export const contextHandler = new ContextHandler();
